package or.garden.manager.domain

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.plugins.HttpTimeout
import io.ktor.client.plugins.auth.Auth
import io.ktor.client.plugins.auth.providers.BearerTokens
import io.ktor.client.plugins.auth.providers.bearer
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.defaultRequest
import io.ktor.client.plugins.observer.ResponseObserver
import io.ktor.client.request.header
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.client.statement.bodyAsText
import io.ktor.client.statement.request
import io.ktor.http.ContentType
import io.ktor.http.HttpHeaders
import io.ktor.http.HttpHeaders.Authorization
import io.ktor.http.content.TextContent
import io.ktor.serialization.kotlinx.json.json
import io.ktor.util.decodeBase64String
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import or.garden.manager.components.LocaleManager
import or.garden.manager.domain.model.ApiResponse
import or.garden.manager.domain.model.GardenUser
import or.garden.manager.domain.model.RefreshTokenRequest

data object GardenHttpClient {
    private var _token: String = ""
    private var _refreshToken: String = ""
    private var _role: String = "USER"
    var unauthorizeHandler: () -> Unit = {}

    var token: String
        get() = _token
        set(value) {
            _token = value
            if (value.isNotBlank()) {
                _role = extractRoleFromToken(value)
            }
        }

    var refreshToken: String
        get() = _refreshToken
        set(value) {
            _refreshToken = value
        }

    val role: String
        get() = _role

    var baseUrl: String = "https://api.garden.car4hire.ba"
    //var baseUrl: String = "http://BATZ-OSMAN-RESIDOVIC:8082"

    // Global API Delay for testing Shimmer/Loaders
    var apiDelayMillis: Long = 500

    private fun extractRoleFromToken(jwtToken: String): String {
        return try {
            val parts = jwtToken.split(".")
            if (parts.size == 3) {
                // Decode the payload (second part)
                val payload = parts[1].decodeBase64String()
                val json = Json.parseToJsonElement(payload).jsonObject
                json["role"]?.jsonPrimitive?.content ?: "USER"
            } else {
                "USER"
            }
        } catch (e: Exception) {
            println("Error extracting role from JWT: ${e.message}")
            "USER"
        }
    }

    val GARDEN_CLIENT: HttpClient by lazy {
        HttpClient {
            install(Auth) {
                bearer {
                    loadTokens {
                        if (token.isNotBlank()) {
                            BearerTokens(token, refreshToken)
                        } else null
                    }
                    refreshTokens {
                        if (refreshToken.isBlank()) {
                            unauthorizeHandler.invoke()
                            return@refreshTokens null
                        }

                        try {
                            val response = client.post("$baseUrl/auth/refresh") {
                                markAsRefreshTokenRequest()
                                setBody(RefreshTokenRequest(refreshToken))
                            }.body<ApiResponse<GardenUser>>()

                            if (response.data != null) {
                                token = response.data.token
                                refreshToken = response.data.refreshToken
                                BearerTokens(token, refreshToken)
                            } else {
                                null
                            }
                        } catch (e: Exception) {
                            null
                        }
                    }
                    sendWithoutRequest { request ->
                        request.url.pathSegments.none { it == "auth" }
                    }
                }
            }

            defaultRequest {
                header(HttpHeaders.Accept, ContentType.Application.Json)
                header(HttpHeaders.ContentType, ContentType.Application.Json)
                header(HttpHeaders.AcceptCharset, "utf-8")
                header("Lang", LocaleManager.lang)
            }

            install(ContentNegotiation) {
                json(Json {
                    ignoreUnknownKeys = true
                    useAlternativeNames = false
                    explicitNulls = false
                    prettyPrint = true
                    isLenient = true
                })
            }

            install(HttpTimeout) {
                requestTimeoutMillis = 60_000
                connectTimeoutMillis = 60_000
                socketTimeoutMillis = 60_000
            }
        }
    }
}